export const periodConfig = {
  separator: ' - ',
  withDate: false,
  withYear: false,
}
